/**
 * How the API's payment-method tokens are shown.
 *
 * The response schema is locked to `CASH`/`CREDIT` with no labels attached
 * (scoping doc: server-driven display text is out of scope), so the words
 * live client-side. The token itself is what gets selected and echoed back to
 * `setCheckoutRuleSession` — these entries only dress it.
 */
export interface PaymentMethodPresentation {
  label: string
  detail: string
  /** The design's "RECOMENDADO" flag. */
  tag?: string
  /** Credit is refused when the order exceeds the line; the screen computes it. */
  limitedByCredit?: boolean
}

export const PAYMENT_METHOD_PRESENTATION: Record<string, PaymentMethodPresentation> = {
  CASH: {
    label: 'Efectivo contra entrega',
    detail: 'Paga al repartidor al recibir',
  },
  CREDIT: {
    label: 'Crédito distribuidor',
    detail: 'Se descuenta de tu línea de crédito',
    tag: 'RECOMENDADO',
    limitedByCredit: true,
  },
}

/**
 * A token the map does not know renders as itself rather than vanishing: the
 * validator only admits CASH/CREDIT today, but if it is ever relaxed (Pix,
 * boleto), an unstyled-but-selectable option beats a method the client system
 * offered and the UI silently dropped.
 */
export const paymentMethodPresentation = (token: string): PaymentMethodPresentation =>
  PAYMENT_METHOD_PRESENTATION[token] ?? { label: token, detail: '' }

export const paymentMethodLabel = (token: string | null): string =>
  token === null ? '—' : paymentMethodPresentation(token).label
